// Old. Some are unused, would need some grooming.
export enum E2eTestElementId {
  ERROR_PAGE = 'test-error-page',
  EDITABLE_TEXT_INPUT = 'test-editable-text-input',
  EDITABLE_TEXT_SAVE = 'test-editable-text-save',
  NET_IMPACT_CHART = 'test-net-impact-chart',
  NET_SCORE = 'test-net-score',
  ABS_TOGGLE = 'test-abs-toggle',
  REL_TOGGLE = 'test-rel-toggle',
  TABLE_DOWNLOAD_LINK = 'test-table-download-link',
  LOGIN_EMAIL = 'test-login-email',
  LOGIN_PASSWORD = 'test-login-password',
  LOGIN_BUTTON = 'test-login-button',
  MOBILE_LOGO = 'test-mobile-logo',
  LOGO = 'test-logo',
  MOBILE_LOGIN = 'test-mobile-login',
  LOGIN = 'test-login',
  MOBILE_SIGNUP = 'test-mobile-signup',
  SIGNUP = 'test-signup',
  MOBILE_LOGOUT = 'test-mobile-logout',
  LOGOUT = 'test-logout',
  MOBILE_SEARCH = 'test-mobile-search',
  DESKTOP_SEARCH = 'test-desktop-search',
  MOBILE_SEARCH_LINK = 'test-mobile-search-link',
  MOBILE_BURGER = 'test-mobile-burger',
  MOBILE_BURGER_CLOSE = 'test-mobile-burger-close',
  USER_DROPDOWN = 'test-user-dropdown',
  DROPDOWN_ACTION_BUTTON = 'test-dropdown-action-button',
  DUPLICATE_BUTTON = 'test-duplicate-button',
  CONFIRM_INPUT = 'test-confirm-input',
  DELETE_BUTTON = 'test-delete-button',
  TABLE_CONTROL_BUTTONS = 'test-table-control-buttons',
  TOGGLE_EDIT = 'test-toggle-edit',
  STOP_EDITING = 'test-stop-editing',
  CONFIRM_BUTTON = 'test-confirm-button',
  SHOW_ADD_MODAL = 'test-show-add-modal',
  COMPANY_VIEW = 'test-company-view',
  GROUPFOLIO_VIEW = 'test-groupfolio-view',
  PRODUCTS_HEADER = 'test-products-header',
  IMPACT_TITLES = 'test-impact-titles',
  IMPACT_DRILLDOWN = 'test-impact-drilldown',
  LENS_DESCRIPTION = 'test-lens-description',
  HISTOGRAM_BAR = 'test-histogram-bar',
  NI_UNIT_DROPDOWN_OPTIONS = 'test-ni-unit-dropdown-options',
  ABSOLUTE_MONETARY_FIGURE_BOX = 'test-absolute-monetary-figure-box',
  RELATIVE_MONETARY_FIGURE_BOX = 'test-relative-monetary-figure-box',
  NI_CHART_TOTAL_SUMS = 'ni-chart-total-sums',
  EXTENDED_COVERAGE_DISCLAIMER = 'test-extended-coverage-disclaimer',
  COMPANY_SCREENER_TABLE = 'test-company-screener-table',
  CONSTITUENT_SCREENER_FUND_SELECTOR_INPUT = 'test-constituent-screener-fund-selector-input',
  CONSTITUENT_SCREENER_TABLE = 'test-constituent-screener-table',
  FUND_SCREENER_TABLE = 'test-fund-screener-table',
  FUND_SCREENER = 'test-fund-screener',
  FUND_SCREENER_NAME_FILTER = 'test-fund-screener-name-filter-input',
  EDIT_SCREENER_COLUMNS = 'test-edit-screener-columns',
  EDIT_SCREENER_COLUMNS_TAB_COMMON = 'test-edit-screener-columns-tab',
  EDIT_SCREENER_COLUMNS_CHECKBOX_COMMON = 'test-edit-screener-columns-checkbox-common',
  EDIT_SCREENER_COLUMNS_SHOW_DATA_BUTTON = 'test-edit-screener-columns-show-data',
  SCREENER_SHOW_MISSING_COLUMNS_BUTTON = 'test-screener-show-missing-columns-button',
  SCREENER_NEXT_PAGE_BUTTON = 'test-screener-next-page-button',
  SCREENER_PREVIOUS_PAGE_BUTTON = 'test-screener-previous-page-button',
  SCREENER_ALL_FILTERS_MODAL_APPLY_BUTTON = 'test-screener-all-filters-modal-apply-button',
  SCREENER_FILTER_SDG_1_ALIGNED_SELECT = 'test-screener-filter-sdg-1-aligned-select',
  PAGINATION_CURRENT_PAGE = 'test-pagination-current-page',
  ACCESSIBLE_PORTFOLIOS_LISTING = 'test-accessible-portfolios-listing',
  GROUPFOLIO_HEADER_NAME = 'test-groupfolio-header-name',
  ENTITY_TITLE_BAR = 'test-entity-title-bar',
  ENTITY_TITLE_BAR_NAME = 'entity-title-bar-name',
  CONSTITUENT_LISTING_TABLE = 'test-constituent-listing-table',
  ASK_AI_LINK = 'test-ask-ai-link',
  MOBILE_ASK_AI_LINK = 'test-mobile-ask-ai-link',
}

// Self-signup user account creation
export enum E2eTestElementId {
  SELF_SIGNUP_FIRST_NAME = 'test-self-signup-first-name',
  SELF_SIGNUP_LAST_NAME = 'test-self-signup-last-name',
  SELF_SIGNUP_COMPANY_NAME = 'test-self-signup-company-name',
  SELF_SIGNUP_EMAIL = 'test-self-signup-email',
  SELF_SIGNUP_PASSWORD = 'test-self-signup-password',
  SELF_SIGNUP_SUBMIT = 'test-self-signup-submit',
  SELF_SIGNUP_LOGIN_LINK = 'test-self-signup-forward-link',
}

export enum E2eTestElementClassName {
  COOKIE_CONSENT_REJECT = 'cky-btn-reject',
}

export function getTestModelEntityTitleElementId(type: string | undefined) {
  return `test-title-${type ?? ''}`;
}

export function getTestDimensionTitleElementId(dimension: string | undefined) {
  return `test-dimension-title-${dimension ?? ''}`;
}

export function getTestImpactScorelementId(dimensionOrImpactCode: string | undefined, valence?: string) {
  if (valence) {
    return `test-impact-${dimensionOrImpactCode ?? ''}-${valence}`;
  } else {
    return `test-impact-${dimensionOrImpactCode ?? ''}`;
  }
}

interface EuTaxonomySummaryTableCellParams {
  metricType: string;
  objective: string;
  activityType: string;
}
export function getTestEuTaxonomySummaryTableCellId(params: EuTaxonomySummaryTableCellParams) {
  const { metricType, objective, activityType } = params;
  return `test-eu-taxonomy-cell-${metricType}-${objective}-${activityType}`;
}

export function getTestImpactCardId(companyId: string) {
  return `test-impact-card-${companyId}`;
}

export function getImpactBarId(dimensionOrImpact: string, valence: string) {
  return `impact-bar-${dimensionOrImpact}-${valence}`;
}

export function getImpactBarDataLabelId(dimensionOrImpact: string, valence: string) {
  return `impact-bar-data-label-${dimensionOrImpact}-${valence}`;
}

export function getScreenerTableCellIdForAllRowsOfColumn(tableId: E2eTestElementId, columnName: string) {
  const columnId = `${tableId}-cell-[0-9]+-${columnName}`;
  return new RegExp(columnId);
}
